module.exports = __webpack_public_path__ + "static/img/title-es.3ff09bba.png";